import { render, staticRenderFns } from "./SettlementComments.vue?vue&type=template&id=1d41a0cd&scoped=true&"
import script from "./SettlementComments.vue?vue&type=script&lang=js&"
export * from "./SettlementComments.vue?vue&type=script&lang=js&"
import style0 from "./SettlementComments.vue?vue&type=style&index=0&id=1d41a0cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d41a0cd",
  null
  
)

export default component.exports